import { render, staticRenderFns } from "./TwModal.vue?vue&type=template&id=007ba814&scoped=true"
import script from "./TwModal.vue?vue&type=script&lang=js"
export * from "./TwModal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TwModal.vue?vue&type=style&index=0&id=007ba814&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "007ba814",
  null
  ,true
)

export default component.exports